const HoroscopesAnnuals = () => import(/* webpackChunkName 'HoroscopeAnnuals' */ '@/components/Horoscopes/HoroscopeAnnual/HoroscopeAnnualsList.vue');
const HoroscopeMonthly = () => import(/* webpackChunkName 'HoroscopeMonthly' */ '@/components/Horoscopes/HoroscopeMonthly/HoroscopeMonthliesList.vue');
const HoroscopeDailies = () => import(/* webpackChunkName 'HoroscopeAnnuals' */ '@/components/Horoscopes/HoroscopeDaily/HoroscopeDailiesList.vue');
const HoroscopeKeywords = () => import(/* webpackChunkName 'HoroscopeAnnuals' */ '@/components/Horoscopes/HoroscopeKeyword/HoroscopeKeywordsList.vue');

export default {
    path: 'horoscopes',
    name: 'horoscopes',
    redirect: 'annuals/',
    meta: {
        label: 'Horoscopes'
    },
    component: {
        name: 'Horoscopes',
        render(c: any) {
            return c('router-view');
        }
    },
    children: [
        {
            path: 'dailies',
            name: 'horoscope_dailies',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Horoscope Dailies'
            },
            component: HoroscopeDailies
        },
        {
            path: 'monthlies',
            name: 'horoscope_monthlies',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Horoscope Monthlies'
            },
            component: HoroscopeMonthly
        },
        {
            path: 'annuals',
            name: 'horoscope_annuals',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Horoscope Annuals'
            },
            component: HoroscopesAnnuals
        },
        {
            path: 'keywords',
            name: 'horoscope_keywords',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Horoscope Keywords'
            },
            component: HoroscopeKeywords
        }
    ]
};